<template>
    <p class="p2">
        <slot />
    </p>
</template>
